import { createApp } from 'vue'
import { LazyLoader } from './plugins/lazy-loader.js';
import SlideMePlugin from './plugins/SlideMe';
import HorizontalScroll from './plugins/HorizontalScroll';
import TimerDown from './plugins/TimerDown'
import http from './plugins/http';
import dFormat from './plugins/dFormat'
import AlertPlugin from './plugins/alert';
import '../assets/styles/main.scss';
import App from '../components/App.vue';
import Search from '../components/Search.vue';
import Cart from '../components/Cart/Cart.vue';
import Single from '../components/Product/Single.vue';
import ModalPopUp from '../components/Special/ModalPopUp.vue';
import Gallery from '../components/Product/Gallery.vue';
import Reviews from '../components/Product/Reviews.vue';
import Products from '../components/Product/Items.vue';
import productFilters from '../components/Product/Filters.vue';
import Checkout from '../components/Cart/Checkout.vue';
import Contact from '../components/Pages/Contact.vue';
import Subscription from '../components/Pages/Subscribe.vue';
import Login from '../components/Account/Login.vue';
import ConfirmOTP from "@/BinaryFlow/components/Account/ConfirmOTP.vue";
import Orders from '../components/Account/Orders.vue';
import InfSlider from '../components/Includes/v-slider.vue';
import '../assets/styles/main.scss';

const APP_MAIN     = '#main-app';
const APP_CONTACT  = '#contact-app';
const APP_SUBS     = '#subs-app';
const APP_CHECKOUT = '#checkout-app';
const APP_FILTERS  = '#product-filters';
const APP_PRODUCT  = '#product-app';
const APP_PRODUCTS = '#products-app';
const APP_GALLERY  = '#product-gallery-app';
const APP_REVIEWS  = '#product-reviews-app';
const APP_REVIEWS_M= '#product_m-reviews-app';
const APP_SEARCH   = '#search-app';
const APP_GRANT    = '#grant-app';
const APP_CART     = '#cart-app';
const APP_LOGIN    = '#acc-app';
const APP_CONFIRM_OTP = '#acc-confirm-otp';
const APP_ORDERS   = '#orders-app';
const INF_SLIDER   = '#inf-slider';

/**
 * Основной блок
 */
function mainApp() {

    const main     = document.querySelector( APP_MAIN )
    const search   = document.querySelector( APP_SEARCH )
    const cart     = document.querySelector( APP_CART )
    const contact  = document.querySelector( APP_CONTACT )
    const subs     = document.querySelector( APP_SUBS )
    const checkout = document.querySelector( APP_CHECKOUT )
    const filters  = document.querySelector( APP_FILTERS )
    const product  = document.querySelector( APP_PRODUCT )
    const products = document.querySelector( APP_PRODUCTS )
    const gallery  = document.querySelector( APP_GALLERY )
    const reviews  = document.querySelector( APP_REVIEWS )
    const reviews_m  = document.querySelector( APP_REVIEWS_M )
    const login    = document.querySelector( APP_LOGIN )
    const confirm_otp = document.querySelector( APP_CONFIRM_OTP )
    const infSlider= document.querySelector( INF_SLIDER )
    const grant= document.querySelector( APP_GRANT )
    const orders= document.querySelector( APP_ORDERS )

    if( main ) {
        const main_app = createApp( App )
        main_app.use(http)
        main_app.use(SlideMePlugin);
        main_app.use(HorizontalScroll);
        main_app.use(TimerDown);
        main_app.use(AlertPlugin);
        main_app.mount( APP_MAIN )
    }

    if( search ) {
        const search_app = createApp( Search )
        search_app.use(http)
        search_app.use(AlertPlugin);
        search_app.mount( APP_SEARCH )
    }

    if( cart ) {
        const cart_app = createApp( Cart )
        cart_app.use(http)
        cart_app.use(AlertPlugin);
        cart_app.mount( APP_CART )
    }

    if( contact ) {
        const contact_app = createApp( Contact )
        contact_app.use(http)
        contact_app.use(AlertPlugin);
        contact_app.mount( APP_CONTACT )
    }

    if( subs ) {
        const subs_app = createApp( Subscription )
        subs_app.use(http)
        subs_app.use(AlertPlugin);
        subs_app.mount( APP_SUBS )
    }

    if( checkout ) {
        const checkout_app = createApp( Checkout )
        checkout_app.use(http)
        checkout_app.use(AlertPlugin);
        checkout_app.mount( APP_CHECKOUT )
    }

    if( filters ) {
        const filters_app = createApp( productFilters )
        filters_app.use(AlertPlugin);
        filters_app.mount( APP_FILTERS )
    }

    if( login ) {
        const login_app = createApp( Login )
        login_app.use(http)
        login_app.use(AlertPlugin);
        login_app.mount( APP_LOGIN )
    }

    if( confirm_otp ) {
        const confirm_otp = createApp( ConfirmOTP )
        confirm_otp.use(http)
        confirm_otp.mount( APP_CONFIRM_OTP )
    }

    if( grant ) {
        const grant_app = createApp( ModalPopUp )
        grant_app.use( http )
        grant_app.use( AlertPlugin );
        grant_app.mount( APP_GRANT )
    }

    if( orders ) {
        const orders_app = createApp( Orders )
        orders_app.use( http )
        orders_app.use(dFormat)
        orders_app.mount( APP_ORDERS )
    }

    if( infSlider ) {
        const infSlider_app = createApp( InfSlider )
        infSlider_app.mount( INF_SLIDER )
    }

    if( products ) {
        const products_app = createApp( Products )
        products_app.use(http)
        products_app.mount( APP_PRODUCTS )
    }

    if( product ) {

        const single_app = createApp( Single )
        single_app.use(http)
        single_app.use(AlertPlugin);
        single_app.mount( APP_PRODUCT )

        if( gallery ) {
            const gallery_app = createApp( Gallery )
            gallery_app.mount( APP_GALLERY )
        }

        if( reviews ) {
            const reviews_app = createApp( Reviews )
            reviews_app.use(http)
            reviews_app.use(AlertPlugin);
            reviews_app.mount( APP_REVIEWS )
        }

        if( reviews_m ) {
            const reviews_app_m = createApp( Reviews )
            reviews_app_m.use(http)
            reviews_app_m.use(AlertPlugin);
            reviews_app_m.mount( APP_REVIEWS_M )
        }
    }
}

const ACCORDION        = '.accordion';
const ACCORDION_ITEM   = '.accordion-item';
const ACCORDION_HEADER = '.accordion-item .accordion-header';

/**
 * управление событиями
 */
function initAccordionEvents() {

    const items = document.querySelectorAll( ACCORDION_HEADER );
    if( items ) items.forEach(item => {
        // Сохраняем ссылку на обработчик
        item.handler = () => {
            toggleAccordion( item );
        };

        // Добавляем обработчик
        item.addEventListener('click', item.handler);
    });
}

/**
 * удаление событий аккордеона
 */
function removeAccordionEvents() {
    const items = document.querySelectorAll( ACCORDION_HEADER );
    if( items ) items.forEach(item => {
        if( item.handler ) {
            item.removeEventListener('click', item.handler);
        }
    });
}

/**
 * Активация аккордеона
 * @param item
 */
function toggleAccordion( item ) {

    const accordion = item.closest( ACCORDION )
    const accordion_item = item.closest( ACCORDION_ITEM )

    // проверяем есть ли у элемента класс active
    if( accordion_item.classList.contains('active') ) {
        accordion_item.classList.remove('active')
        return;
    }

    // Открываем текущий
    accordion_item.classList.toggle('active');
}

/**
 * Отслеживание scroll для элемента .header
 */

// Константы для оптимизации
const HEADER_SELECTOR = '.header'; // Селектор для поиска заголовка
const SCROLL_THRESHOLD = 10; // Порог для добавления класса

let header; // Кэширование DOM-элемента
let lastScrollTop = 0;
let tick = null;

/**
 * Обработчик события scroll
 */
function handleScroll() {

    if( ! header ) return; // Проверка существования header

    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // Обработка отрицательных значений
    if( scrollPosition < 0 ) return;

    // Debouncing для оптимизации
    clearTimeout(tick);

    tick = setTimeout(() => {
        // Добавление/удаление класса
        if (scrollPosition > SCROLL_THRESHOLD) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        lastScrollTop = scrollPosition;
    }, 100);
}

/**
 * Инициализация функционала scroll
 */
function scrollInit() {

    // Кэшируем элемент header один раз
    header = document.querySelector( HEADER_SELECTOR );
    if( ! header )
        return;

    // Проверяет текущую позицию scroll и назначает класс
    handleScroll()

    // Добавляет слушателя
    window.addEventListener('scroll', handleScroll, { passive: true });
}

/**
 * Запуск скриптов после инициализации DOM
 */
document.addEventListener('DOMContentLoaded', () => {
    scrollInit();
    mainApp();
    initAccordionEvents();

    window.lazyLoader = new LazyLoader({
        fallbackSrc: '/templates/BinaryFlow/assets/images/placeholder.png'
    });
    window.lazyLoader.init();
})

/**
 * Очистка событий
 */
window.addEventListener('beforeunload', function() {
    removeAccordionEvents();
});